/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgTextLong = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.36011 4C1.36011 3.42562 1.82573 2.96 2.40011 2.96H6.40011C6.97448 2.96 7.44011 3.42562 7.44011 4C7.44011 4.57438 6.97448 5.04 6.40011 5.04H2.40011C1.82573 5.04 1.36011 4.57438 1.36011 4ZM1.36011 8C1.36011 7.42562 1.82573 6.96 2.40011 6.96H13.6001C14.1745 6.96 14.6401 7.42562 14.6401 8C14.6401 8.57438 14.1745 9.04 13.6001 9.04H2.40011C1.82573 9.04 1.36011 8.57438 1.36011 8ZM1.36011 12C1.36011 11.4256 1.82573 10.96 2.40011 10.96H13.6001C14.1745 10.96 14.6401 11.4256 14.6401 12C14.6401 12.5744 14.1745 13.04 13.6001 13.04H2.40011C1.82573 13.04 1.36011 12.5744 1.36011 12Z'
    />
  </svg>
)
export default SvgTextLong
